import { Component, OnInit } from '@angular/core';
import {TitleComponent} from "../title/title.component";
import {Router} from "@angular/router";

@Component({
  selector: 'app-security',
  templateUrl: './security.component.html',
  styleUrls: ['./security.component.css']
})
export class SecurityComponent implements OnInit {

  constructor(
    private title : TitleComponent,
    public router: Router
  ) { }

  ngOnInit() {
  }

  goToLink(){
    this.router.navigate(['/login']);

  }

}



// WEBPACK FOOTER //
// D:/Sonali/JCCBViewOnlyProject/ViewOnlyJCCBfrontend19112022/InternetBanking6.3frontend/src/app/security/security.component.ts